import { connectRefinementList } from "react-instantsearch-dom";
import parse from 'html-react-parser';
import styled from "styled-components";
import {useTranslation} from "react-i18next";

const BuildingSystemBox = styled.div`
max-width: 45%;
min-width: 45%;
height: 56px;
border: ${props => props.checked ? "solid 3px #626262;" : "solid 1px #626262;"};
background-color: #fff;
padding: 0px 9px 0px 9px;
cursor: pointer;
-webkit-box-pack: center;
-ms-flex-pack: center;
justify-content: center;
-webkit-box-align: center;
-ms-flex-align: center;
align-items: center;
display:flex;



:hover {
  border: ${props => props.checked ? "solid 3px #626262;" : "solid 1px #909090;"};
}


}`;


const BuildingSystemBoxDisabled = styled.div`
max-width: 45%;
min-width: 45%;
height: 56px;
border: solid 1px rgba(44, 39, 28, 0.5);
background-color: #fff;
padding: 0px 9px 0px 9px;
cursor: pointer;
-webkit-box-pack: center;
-ms-flex-pack: center;
justify-content: center;
-webkit-box-align: center;
-ms-flex-align: center;
align-items: center;
display:flex;



}`;

const BuildingSystemKey = styled.span`
  float: right;
  position: relative;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display:flex;
}`;

const BuildingSystemLabelDisabled = styled.span`
margin: 0 35px 0 0;
  font-family: Open Sans, sans-serif;;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
   color: rgba(44, 39, 28, 0.5);
  line-height: 22px;

}`;

const BuildingSystemLabel = styled.span`
margin: 0 35px 0 0;
  font-family: Open Sans, sans-serif;;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1;
  letter-spacing: normal;
  text-align: left;
  color: #2c271c;
  line-height: 22px;

  ${BuildingSystemBox}:hover & {
    color: #2c271c;
    opacity: 0.7;
  }

}`;

const BuildingSystemMarker = styled.span`
  display: inline-flex;
  width: 16.3px;
  height: 16.3px;
  border-radius: 50%;
  background-color: ${props => props.inputColor || '#025c9b' };
}`;

const BuildingSystemCount = styled.span`
border: none;
font-family: Open Sans, sans-serif;;
font-size: 12px;
font-weight: 600;
font-stretch: normal;
font-style: normal;
line-height: 1.42;
letter-spacing: normal;
text-align: center;
color: ${props => props.textColor || '#025c9b' };
text-align: center;
text-decoration: none;
display: inline-block;
padding: 1px 4px 1px;
border-radius: 10px;
background-color: ${props => props.inputColor || '#B2CEE1' };
margin-left: 5px;
}`;

const RefinementList = ({
  values,
  currentRefinement,
  items,
  refine,
  createURL,
}) => {

  const { t, i18n } = useTranslation();


  return (
    <div style={{ display: "flex", justifyContent: "space-between" }} className='building-refinement-list'>
    {values.map(staticItem => {
      const { isRefined } = items.find(
          item => item.label === staticItem.label
        ) || {
          isRefined: false,
        };

        const { count } = items.find(
            item => item.label === staticItem.label
          ) || {
            count: 0,
          };

          const markerColor = staticItem.label !== t('MassTimber') ? '#E7B940' : '#025C9B';
          const countTextColor = staticItem.label !== t('MassTimber') ? '#A26700' : '#025c9b';
          const countMarkerColor = staticItem.label !== t('MassTimber') ? '#F8EAC5' : '#B2CEE1';

          const showBuildingSystemBox = staticItem.label === t('MassTimber') ? true : false;
          const staticLabel = staticItem.label === t('MassTimber') ? t('MassTimber') : t('LightFrame')


        return (
      <BuildingSystemBox
        key={staticItem.label}
        checked={isRefined}
        onClick={event => {
          const item = items.find(i => i.label === staticItem.label)
          event.preventDefault();
          refine(item.value);
        }}
      >
        <BuildingSystemLabel>{parse(staticLabel)}</BuildingSystemLabel>
        <BuildingSystemKey>
          <BuildingSystemMarker inputColor={markerColor}/>
          <BuildingSystemCount textColor={countTextColor} inputColor={countMarkerColor}>{count}</BuildingSystemCount>
        </BuildingSystemKey>
      </BuildingSystemBox>



  )
})}
  </div>
  );
};
const BuildingSystemRefinementList = connectRefinementList(RefinementList);

export default BuildingSystemRefinementList;
